import { IconName } from 'components/ui/icon'

import { UserRole } from 'features/user/types'

export type NavItem = {
  to: string
  label: string
  icon: IconName
}

/** Navigation entries available to the logged user, in display order. */
export const getNavItems = (
  role: string | null,
  showBiMenu: boolean
): NavItem[] => {
  const isDoctor = role === UserRole.DOCTOR
  const isHospitalAdmin = role === UserRole.HOSPITAL_ADMIN
  const isAdmin = role === UserRole.ADMIN
  const items: NavItem[] = []

  if (isDoctor || isHospitalAdmin) {
    items.push({ to: '/transfers', label: 'Repasses', icon: 'transfers' })
  }

  if (showBiMenu) {
    items.push({ to: '/bi-medico', label: 'Bi Médico', icon: 'chart' })
  }

  if (isDoctor || isAdmin) {
    items.push({ to: '/hospitals', label: 'Hospitais', icon: 'hospital' })
  }

  if (isAdmin) {
    items.push({ to: '/users', label: 'Usuários', icon: 'users' })
  }

  if (isHospitalAdmin) {
    items.push({
      to: '/access-requests',
      label: 'Solicitações de acesso',
      icon: 'access',
    })
    items.push({ to: '/doctors', label: 'Médicos', icon: 'doctor' })
  }

  return items
}
